import { render, staticRenderFns } from "./select-color.vue?vue&type=template&id=057ef59e&"
import script from "./select-color.vue?vue&type=script&lang=js&"
export * from "./select-color.vue?vue&type=script&lang=js&"
import style0 from "./select-color.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('057ef59e')) {
      api.createRecord('057ef59e', component.options)
    } else {
      api.reload('057ef59e', component.options)
    }
    module.hot.accept("./select-color.vue?vue&type=template&id=057ef59e&", function () {
      api.rerender('057ef59e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/select-color.vue"
export default component.exports